var components
try {
  components = {
    uTabsSwiper: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-tabs-swiper/u-tabs-swiper" */ "uview-ui/components/u-tabs-swiper/u-tabs-swiper.vue"
      )
    },
    empty: function () {
      return import(
        /* webpackChunkName: "components/empty/empty" */ "@/components/empty/empty.vue"
      )
    },
    uParse: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-parse/u-parse" */ "uview-ui/components/u-parse/u-parse.vue"
      )
    },
    uCollapse: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-collapse/u-collapse" */ "uview-ui/components/u-collapse/u-collapse.vue"
      )
    },
    uCollapseItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-collapse-item/u-collapse-item" */ "uview-ui/components/u-collapse-item/u-collapse-item.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.vk.pubfn.isNotNull(_vm.chapters)
  var l1 = g0
    ? _vm.__map(_vm.chapters, function (chapter, index) {
        var $orig = _vm.__get_orig(chapter)
        var l0 = _vm.__map(chapter.videos, function (item, index2) {
          var $orig = _vm.__get_orig(item)
          var g1 = !(_vm.video._id == item._id && _vm.isBuy)
            ? _vm.vk.pubfn.isNotNull(item.watch_info)
            : null
          var f0 =
            !(_vm.video._id == item._id && _vm.isBuy) && !g1
              ? _vm._f("durationForHuman")(item.duration)
              : null
          return {
            $orig: $orig,
            g1: g1,
            f0: f0,
          }
        })
        return {
          $orig: $orig,
          l0: l0,
        }
      })
    : null
  var g2 = _vm.vk.pubfn.isNotNull(_vm.chapters)
  var l2 = g2
    ? _vm.__map(_vm.chapters, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g3 = _vm.vk.pubfn.isNotNull(item.word)
        return {
          $orig: $orig,
          g3: g3,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l1: l1,
        g2: g2,
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }